<template>
  <d-container fluid>
    <d-row>
      <!-- Main Sidebar -->
      <main-sidebar :items="getFilteredSidebarItems" />

      <d-col class="main-content pb-4 offset-lg-2 offset-md-3 p-0" tag="main" lg="10" md="9" sm="12">
        <div id="scroll-detector"></div>
        <!-- Content -->
        <slot />
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import getSidebarItems from '@/data/sidebar-nav-items';
import MainSidebar from '@/components/layout/MainSidebar/MainSidebar.vue';

export default {
  name: 'main-view',
  components: {
    MainSidebar
  },
  computed: {
    getFilteredSidebarItems () {
      return getSidebarItems().filter(item => item.permission === false || this.$store.getters.getUserPermission(item.permission));
    }
  },
  data () {
    return {
      scrollObserver: null,
      scrollDetector: null
    };
  },
  mounted () {
    if ('IntersectionObserver' in window) {
      this.scrollDetector = document.querySelector('#scroll-detector');
      this.scrollObserver = new IntersectionObserver(
        ([e]) => {
          if (e.intersectionRatio === 0) {
            document.body.classList.add('is-scrolled');
          }

          if (e.intersectionRatio === 1) {
            document.body.classList.remove('is-scrolled');
          }
        },
        {
          threshold: [0, 1]
        }
      );

      this.scrollObserver.observe(this.scrollDetector);
    }

    document.body.classList.add('js-not-close-modals-on-backdrop-click');
  },
  beforeDestroy () {
    if ('IntersectionObserver' in window && this.scrollObserver) {
      this.scrollObserver.unobserve(this.scrollDetector);
    }
  }
};
</script>

<style lang="scss">
body > .container-fluid,
body > .container-fluid > .row {
  min-height: 100vh;
}

body > .container-fluid > .row > .main-content {
  position: relative;
}

.modal {
  left: 220px;
  width: calc(100% - 220px);
}

#scroll-detector {
  background: transparent;
  height: 1px;
  width: 100%;
}
</style>
